var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavenew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5950_25352",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5950_25352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6 22H18.4V18.4H22V17.6H18.4V14H17.6V17.6H14V18.4H17.6V22Z",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 13.9996V7L17 3H5C4.45 3 3.979 3.19567 3.587 3.587C3.19567 3.979 3 4.45 3 5V19C3 19.55 3.19567 20.021 3.587 20.413C3.979 20.8043 4.45 21 5 21H13.9997C13.563 20.4186 13.25 19.7389 13.1 19H5V5H16.15L19 7.85V13.1C19.7389 13.2499 20.4186 13.5629 21 13.9996ZM14.8721 14.0989C14.7343 13.6433 14.4853 13.2353 14.125 12.875C13.5417 12.2917 12.8333 12 12 12C11.1667 12 10.4583 12.2917 9.875 12.875C9.29167 13.4583 9 14.1667 9 15C9 15.8333 9.29167 16.5417 9.875 17.125C10.4583 17.7083 11.1667 18 12 18C12.3571 18 12.6913 17.9464 13.0025 17.8393C13.0503 16.327 13.7696 14.9841 14.8721 14.0989ZM15 10H6V6H15V10Z",
    fill: "#858585"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavenew);
export default __webpack_public_path__ + "static/media/savenew.9d97afcf.svg";
export { ForwardRef as ReactComponent };